module.exports = {
    newZoneTicket: "/",
    retireeProducts: "/retireetickets/",
    newRetireeTicket: "/retireeticket/",
    fixedPriceProducts: "/fixedpricetickets/",
    newFixedPriceTicket: "/fixedpriceticket/",
    customerInformation: "/customerinfo/",
    confirmBasket: "/confirmbasket/"
};
